import { Box, Button, Divider, Image, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import * as React from 'react';
import Link from 'next/link';
import { Logo } from './Logo';
import { LinkType } from './navBar/NavContent';

const links: { product: LinkType[]; resources: LinkType[]; legal: LinkType[] } = {
  product: [
    {
      title: 'Features',
      url: '/#features'
    },
    {
      title: 'How it works',
      url: '/#how-it-works'
    },
    {
      title: 'Contact us',
      url: '/#contact-us'
    }
  ],
  resources: [
    {
      title: 'Status',
      url: 'https://eezi.instatus.com'
    },
    {
      title: 'Documentation',
      url: 'https://docs.eezi.io/docs/overview'
    }
  ],
  legal: [
    {
      title: 'Terms of service',
      url: '/legal/terms'
    },
    {
      title: 'Privacy policy',
      url: '/legal/policy'
    }
  ]
};

export const Footer = () => (
  <Box px={4}>
    <Stack spacing='8' direction={{ base: 'column', md: 'row' }} justify='space-between' py={{ base: '12', md: '16' }}>
      <Stack spacing={{ base: '6', md: '8' }} align='start'>
        <Logo h='100px' mx={{ base: 'auto', sm: 'inherit' }} />
        <Stack
          spacing={{ base: 10, sm: '4' }}
          direction={{ base: 'column', sm: 'row' }}
          justify='space-between'
          width='100%'
        >
          <Image
            src='/images/certified-peppol.png'
            w='187px'
            h='78px'
            alt='Peppol - Certified provider'
            mx={{ base: 'auto', sm: 'inherit' }}
          />
          <Image src='/images/Gena_logo_v3.png' w='187' h='78px' alt='Gena logo' mx={{ base: 'auto', sm: 'inherit' }} />
        </Stack>
      </Stack>
      <Stack direction={{ base: 'column-reverse', md: 'column', lg: 'row' }} spacing={{ base: '12', md: '8' }}>
        <Stack
          direction={{ base: 'column-reverse', sm: 'row', md: 'row', lg: 'row' }}
          spacing='8'
          mx={{ base: 'auto', lg: '' }}
        >
          <Stack spacing='4' minW='36' flex='1'>
            <Text fontSize='sm' fontWeight='bold' color={useColorModeValue('brand', 'whiteAlpha.600')}>
              Product
            </Text>
            <Stack spacing='3' shouldWrapChildren>
              {links.product.map((link) => (
                <Link href={link.url} key={link.title}>
                  <Button variant='link' {...link.props} color={useColorModeValue('brand', 'whiteAlpha.900')}>
                    {link.title}
                  </Button>
                </Link>
              ))}
            </Stack>
          </Stack>
          <Stack spacing='4' minW='36' flex='1'>
            <Text fontSize='sm' fontWeight='bold' color={useColorModeValue('brand', 'whiteAlpha.600')}>
              Resources
            </Text>
            <Stack spacing='3' shouldWrapChildren>
              {links.resources.map((link) => (
                <Link href={link.url} key={link.title}>
                  <Button variant='link' {...link.props} color={useColorModeValue('brand', 'whiteAlpha.900')}>
                    {link.title}
                  </Button>
                </Link>
              ))}
            </Stack>
          </Stack>
          <Stack spacing='4' minW='36' flex='1'>
            <Text fontSize='sm' fontWeight='bold' color={useColorModeValue('brand', 'whiteAlpha.600')}>
              Legal
            </Text>
            <Stack spacing='3' shouldWrapChildren>
              {links.legal.map((link) => (
                <Link href={link.url} key={link.title}>
                  <Button variant='link' {...link.props} color={useColorModeValue('brand', 'whiteAlpha.900')}>
                    {link.title}
                  </Button>
                </Link>
              ))}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
    <Divider />
    <Stack
      pt='8'
      pb='4'
      justify='space-between'
      direction={{ base: 'column-reverse', md: 'row' }}
      align='center'
      color={useColorModeValue('whiteAlpha.900', 'whiteAlpha.700')}
    >
      <Text fontSize='sm' color={useColorModeValue('gray.400', 'gray.600')}>
        &copy;
        {`${new Date().getFullYear()} `}
        All rights reserved.
      </Text>
    </Stack>
  </Box>
);
